import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserLink } from '../activityTypes/userLink/userLink';
import { ConversationLink } from './conversationLink/conversationLink';
import { UserActivityCard } from './userActivityCard';
import { channelRefIcon, statusColors } from './userActivityTypes.utils';

type ConversationAssignedProps = {
  entry: UserAuditLogEntry<'CONVERSATION_ASSIGNED'>;
};

export const ConversationAssigned = ({
  entry,
}: ConversationAssignedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon={channelRefIcon(entry.channel_ref)}
    color={statusColors.info}
    title={
      entry.is_reassigned
        ? 'Reassigned to conversation'
        : 'Assigned to conversation'
    }
    titleSuffix={
      <ConversationLink
        conversationId={entry.conversation_id}
        onClick={(event) => event.stopPropagation()}
      >
        #{entry.conversation_id}
      </ConversationLink>
    }
    summary={
      entry.contact_id && (
        <>
          {'With '}
          <UserLink
            userId={entry.contact_id}
            onClick={(event) => event.stopPropagation()}
          >
            {entry.contact_name ?? entry.contact_id}
          </UserLink>
        </>
      )
    }
  />
);
